$(() => {
  $('.promotions-slide').slick({
    dots: true,
  });
});
